import { Box, Stack } from '@mui/material'
import React from 'react'
import { useTranslation } from '../../../../../common/hooks/helper/useTranslation'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import ErrorIcon from '@mui/icons-material/Error'
import {
  BetmenList,
  BetmenListHeader,
  BetmenListHeaderCell,
  BetmenListBody,
  BetmenListItemCard,
  BetmenListItemCardCell,
} from '../../../../../common/components'
import { UsePatientEProfileReturn } from '../../hooks/usePatientEProfile'
import { Risk } from '../../../../../models/graphqlTypes'
import { PatientDetailsSectionHeader } from './PatientDetailsSectionHeader'
import { PatientDetailsActions } from './PatientDetailsActions'

export const PatientWarnings: React.FC<UsePatientEProfileReturn> = ({
  patientDetails,
  isLoading,
  isEditable,
}) => {
  const { t } = useTranslation()

  const hasData = patientDetails.warnings.length > 0

  return (
    <Box bgcolor={'warning.light'} py={2} borderRadius={3}>
      <PatientDetailsSectionHeader
        icon={<WarningAmberIcon fontSize="large" />}
        title={t('doctor:patientProfile.warnings.title')}
        hasData={hasData}
      />

      {(isLoading || hasData) && (
        <BetmenList
          dataSource={patientDetails.warnings}
          loading={isLoading}
          gridColumnSizes={[1, 2, 1, 5, 2, 1]}
          extraHeaderStyle={{ backgroundColor: 'transparent' }}
          stickyHeader={false}
          header={
            <BetmenListHeader>
              <BetmenListHeaderCell>
                {t('doctor:patientProfile.warnings.header.type')}
              </BetmenListHeaderCell>
              <BetmenListHeaderCell>
                {t('doctor:patientProfile.warnings.header.cause')}
              </BetmenListHeaderCell>
              <BetmenListHeaderCell>
                {t('doctor:patientProfile.warnings.header.agent')}
              </BetmenListHeaderCell>
              <BetmenListHeaderCell>
                {t('doctor:patientProfile.warnings.header.reaction')}
              </BetmenListHeaderCell>
              <BetmenListHeaderCell>
                {t('doctor:patientProfile.warnings.header.risk')}
              </BetmenListHeaderCell>
            </BetmenListHeader>
          }
        >
          <BetmenListBody>
            {patientDetails.warnings.map((warning) => (
              <BetmenListItemCard key={warning.id}>
                <BetmenListItemCardCell
                  typographyProps={{ fontWeight: 400, color: 'grey.400' }}
                >
                  {t(
                    `doctor:patientProfile.warnings.type.${warning.type.toLowerCase()}`
                  )}
                </BetmenListItemCardCell>
                <BetmenListItemCardCell typographyProps={{ fontWeight: 700 }}>
                  {warning.cause}
                </BetmenListItemCardCell>
                <BetmenListItemCardCell typographyProps={{ fontWeight: 400 }}>
                  {warning.agent}
                </BetmenListItemCardCell>
                <BetmenListItemCardCell typographyProps={{ fontWeight: 400 }}>
                  {warning.reaction}
                </BetmenListItemCardCell>
                <BetmenListItemCardCell>
                  {warning.risk && (
                    <Stack direction="row" alignItems="center" gap={1}>
                      {t(
                        `doctor:patientProfile.warnings.risk.${warning.risk.toLowerCase()}`
                      )}
                      {warning.risk === Risk.High && (
                        <ErrorIcon fontSize="large" color="warning" />
                      )}
                    </Stack>
                  )}
                </BetmenListItemCardCell>

                <PatientDetailsActions isEditable={isEditable} />
              </BetmenListItemCard>
            ))}
          </BetmenListBody>
        </BetmenList>
      )}
    </Box>
  )
}
